import { SuperModel } from './super-model';

export class WeightageModel extends SuperModel {
	isReadonly: boolean;
	isHidden: boolean;
	fieldType: FieldType;
	fieldColumn: string;
	isRequired: boolean;
	additionalMetaData: MetadataBuilder = {};
	validationMessage?: string;
	fieldCaption: string;
	value?= 0;
	constructor(
		field
	) {
		super(field);
		this.value = field.value;
		this.additionalMetaData = field.additionalMetaData;
		if ([null, undefined].includes(this.additionalMetaData)) {
			this.additionalMetaData = {};
		}
		if (!this.additionalMetaData.hasOwnProperty('showLabel')) {
			this.additionalMetaData.showLabel = true;
		}
		if (!this.additionalMetaData.hasOwnProperty('changeEventEmit')) {
			this.additionalMetaData.changeEventEmit = true;
		}
		if (!this.additionalMetaData.hasOwnProperty('showHelp')) {
			this.additionalMetaData.showHelp = false;
		}
		if (!this.additionalMetaData.hasOwnProperty('maxWeightage')) {
			this.additionalMetaData.maxWeightage = 5;
		} else if (Array.isArray(this.additionalMetaData.maxWeightage) && this.additionalMetaData.maxWeightage.length) {
			field.additionalMetaData.maxWeightage = [{
				key: null,
				value: 'None',
				weightage: 0
			}].concat(field.additionalMetaData.maxWeightage);
		}
		if (!this.additionalMetaData.hasOwnProperty('defaultWeightage')) {
			this.additionalMetaData.defaultWeightage = 1;
		}
		if (!this.additionalMetaData.hasOwnProperty('minWeightage')) {
			this.additionalMetaData.minWeightage = 0;
		}
		if (!this.additionalMetaData.hasOwnProperty('expectedWeightage')) {
			this.additionalMetaData.expectedWeightage = 0;
		}
	}
}

type FieldType = 'weightage';

interface MetadataBuilder {
	showLabel?: boolean;
	changeEventEmit?: boolean;
	maxWeightage?: number | Array<{
		key: any;
		value: string;
		weightage?: number;
		description?: string;
	}>;
	defaultWeightage?: number;
	minWeightage?: number;
	expectedWeightage?: number;
	showHelp?: boolean;
	removable?: boolean;
}
